// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./files/helvetica-neue-light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./files/helvetica-neue-medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./files/helvetica-neue-bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Helvetica Neue';
    font-style: normal;
    font-display: swap;
    font-weight: 200;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
}

@font-face {
    font-family: 'Helvetica Neue';
    font-style: normal;
    font-display: swap;
    font-weight: 300;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
}

@font-face {
    font-family: 'Helvetica Neue';
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}

@font-face {
    font-family: 'Helvetica Neue';
    font-style: normal;
    font-display: swap;
    font-weight: 600;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}

@font-face {
    font-family: 'Helvetica Neue';
    font-style: normal;
    font-display: swap;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
}

@font-face {
    font-family: 'Helvetica Neue';
    font-style: normal;
    font-display: swap;
    font-weight: 900;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
}
`, "",{"version":3,"sources":["webpack://./src/assets/fonts/helveticaNeue/index.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2DAA0D;AAC9D;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2DAA0D;AAC9D;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2DAA2D;AAC/D;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2DAA2D;AAC/D;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2DAAyD;AAC7D;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2DAAyD;AAC7D","sourcesContent":["@font-face {\n    font-family: 'Helvetica Neue';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 200;\n    src: url(./files/helvetica-neue-light.woff) format('woff');\n}\n\n@font-face {\n    font-family: 'Helvetica Neue';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 300;\n    src: url(./files/helvetica-neue-light.woff) format('woff');\n}\n\n@font-face {\n    font-family: 'Helvetica Neue';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 400;\n    src: url(./files/helvetica-neue-medium.woff) format('woff');\n}\n\n@font-face {\n    font-family: 'Helvetica Neue';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 600;\n    src: url(./files/helvetica-neue-medium.woff) format('woff');\n}\n\n@font-face {\n    font-family: 'Helvetica Neue';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 700;\n    src: url(./files/helvetica-neue-bold.woff) format('woff');\n}\n\n@font-face {\n    font-family: 'Helvetica Neue';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 900;\n    src: url(./files/helvetica-neue-bold.woff) format('woff');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
